export default __webpack_public_path__ + "static/0010-IMG_0401-e0ac6c71de6cfe18d72d91ed68030831.jpg";